import { Warning } from 'basic-components/icons';

import './NoColumnsWarning.scss';

const NoColumnsWarning = () => (
  <div className="ng-office-app__authed__content__body__item__datapoint-modal__columns__warning">
    <div className="ng-office-app__authed__content__body__item__datapoint-modal__columns__warning__icon">
      <Warning
          bgColor="orange-base"
          color="white-base"
          height={16}
          width={16}
      />
    </div>
    <div className="ng-office-app__authed__content__body__item__datapoint-modal__columns__warning__text">
      Selected items do not have any common columns available. Please insert data points individually.
    </div>
  </div>
)

export default NoColumnsWarning